<template>
  <div>
    <div
      v-if="isEditing"
      class="editor-heading">

      <input-textarea
        variant="standardInput"
        inputName="text"
        inputLabel="Tekst:"
        inputPlaceholder="Tekst"
        smaller
        transparent
        :inputValue="getEditedParts.text"
        @fieldUpdate="updateContentField" />

      <div class="text-center">
        <input-button
          variant="standardInput"
          btnStyle="ok-style"
          :inputPlaceholder="$t('Button.save')"
          smaller
          boxy
          @click="updateContent()" />

        <input-button
          variant="standardInput"
          btnStyle="default-style"
          :inputPlaceholder="$t('Button.cancel')"
          smaller
          boxy
          @click="toggleEditContent(false)" />

      </div>
    </div>
    <div v-else>
      <button
        class="mb-2"
        @click="toggleEditContent(true)">

        <icon name="pencil" />
      </button>

      <component
        :is="p.tag"
        v-for="p in displayParts"
        :key="p.name"
        class="content-line">

        {{ getEditedParts[p.name] }}
      </component>
    </div>
  </div>
</template>

<script>
import InputButton from '@/components/standard/input/InputButton'
import InputTextarea from '@/components/standard/input/InputTextarea'
import contentEditor from '@/mixins/service/administration/contentEditor'

export default {
  components: {
    'input-button': InputButton,
    'input-textarea': InputTextarea
  },

  mixins: [
    contentEditor
  ]
}
</script>

<style scoped>
button {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/service/administration/editor/SnippetEditor.vue?2164516d